// extracted by mini-css-extract-plugin
export default {"header-vendor":"HeaderVendor_header-vendor__n-epR","vendor-menu-icon":"HeaderVendor_vendor-menu-icon__yOkPb","logo":"HeaderVendor_logo__wul5z"};